module.exports = __webpack_public_path__ + "static/media/AvantRegular.85ebe170.otf";